let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bk0Zi")).then(() => parcelRequire('8EDnk'));